module.exports = __webpack_public_path__ + "static/media/restart.459231aa.svg";